module.exports = __webpack_public_path__ + "img/warranty.aa4c8e38.svg";